export const getTiposVehiculoSinPaginado = () => async (dispatch) => {
  var axios = require("axios");
  var token = localStorage.getItem("tokenControl");

  var config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_SERVER_CONTROL}tipovehiculo?page=1&maxObjectsPerPage=30`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: "GET_TIPOS_VEHICULO_SIN_PAGINADO",
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
      dispatch({
        type: "GET_TIPOS_VEHICULO_SIN_PAGINADO",
        payload: { data: [] },
      });
    });
};

export const getColorSinPaginado = () => async (dispatch) => {
  var axios = require("axios");
  var token = localStorage.getItem("tokenControl");

  var config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_SERVER_CONTROL}colorvehiculo?page=1&maxObjectsPerPage=30`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: "GET_COLORES_VEHICULO_SIN_PAGINADO",
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getModelosSinPaginado = () => async (dispatch) => {
  var axios = require("axios");
  var token = localStorage.getItem("tokenControl");

  var config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_SERVER_CONTROL}modelovehiculo?page=1&maxObjectsPerPage=30`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: "GET_MODELOS_SIN_PAGINADO",
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getMarcasSinPaginado = () => async (dispatch) => {
  var axios = require("axios");
  var token = localStorage.getItem("tokenControl");

  var config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_SERVER_CONTROL}marcavehiculo?page=1&maxObjectsPerPage=30`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: "GET_MARCAS_VEHICULO_SIN_PAGINADO",
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getEmpresasSinPaginado = () => async (dispatch) => {
  var axios = require("axios");
  var token = localStorage.getItem("tokenControl");

  var config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_SERVER_CONTROL}empresaseguro?page=1&maxObjectsPerPage=30`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: "GET_EMPRESAS_SEGURO_VEHICULO_SIN_PAGINADO",
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const addVehicleWithImages =
  (vehicleInfo, images) => async (dispatch) => {
    const axios = require("axios");
    try {
      const vehiclePayload = {
        invitadoid: vehicleInfo.invitadoid,
        patente: vehicleInfo.patente,
        tipovehiculoid: vehicleInfo.tipovehiculoid,
        origenvehichuloid: vehicleInfo.origenvehichuloid,
        marcavehiculoid: vehicleInfo.marcavehiculoid,
        modelovehiculoid: vehicleInfo.modelovehiculoid,
        colorvehiculoid: vehicleInfo.colorvehiculoid,
        empresa_seguro: vehicleInfo.empresa_seguro,
        numero_poliza: vehicleInfo.numero_poliza,
        vencimiento_poliza: vehicleInfo.vencimiento_poliza,
        cedulaverde: vehicleInfo.cedulaverde,
        vtocedula: vehicleInfo.vtocedula,
        comentarios: vehicleInfo.comentarios,
      };

      // console.log('Sending vehiclePayload:', vehiclePayload);

      const vehicleResponse = await axios.post(
        `${process.env.REACT_APP_SERVER_CONTROL}vehiculo/add`,
        vehiclePayload
      );

      const vehicleId = vehicleResponse.data.message
        .split("ID: ")[1]
        .split(",")[0];

      // Convert base64 to blob
      const base64ToBlob = async (base64Data) => {
        const base64WithoutPrefix = base64Data.split(",")[1];
        const byteCharacters = atob(base64WithoutPrefix);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: "image/jpeg" });
      };

      // Upload vehicle image
      if (images.imageCar) {
        const imageBlob = await base64ToBlob(images.imageCar);
        const formData = new FormData();
        formData.append("file", imageBlob, "vehicle.jpg");

        await axios.post(
          `${process.env.REACT_APP_SERVER_CONTROL}image-vehiculo`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }

      // Upload green card image
      if (images.imageGreenCard) {
        const imageBlob = await base64ToBlob(images.imageGreenCard);
        const formData = new FormData();
        formData.append("file", imageBlob, "cedula.jpg");

        try {
          await axios.post(
            `${process.env.REACT_APP_SERVER_CONTROL}vehiculo-cedulaverde/${vehicleId}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
        } catch (error) {
          console.error(
            "Error uploading cedula verde:",
            error.response?.data || error
          );
        }
      }

      // Upload policy image
      if (images.imagePolicy) {
        const imageBlob = await base64ToBlob(images.imagePolicy);
        const formData = new FormData();
        formData.append("file", imageBlob, "poliza.jpg");

        try {
          await axios.post(
            `${process.env.REACT_APP_SERVER_CONTROL}vehiculo-poliza/${vehicleId}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
        } catch (error) {
          console.error(
            "Error uploading poliza:",
            error.response?.data || error
          );
        }
      }

      return { success: true, vehicleId };
    } catch (error) {
      console.error("Error in addVehicleWithImages:", error);
      return { success: false, error };
    }
  };

// Helper function to convert base64 to File
const convertToFile = (base64String) => {
  const arr = base64String.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], "image.jpg", { type: mime });
};

export const getDatosMenuPrincipalInvitado = (info) => async (dispatch) => {
  var axios = require("axios");
  try {
    const token = localStorage.getItem("tokenControl");

    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER_CONTROL}datosMenuPrincipalInvitado`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      data: info,
    });

    // console.log('Response from datosMenuPrincipalInvitado:', response.data);

    if (response.data.status === true) {
      dispatch({
        type: "GET_DATOS_MENU_PRINCIPAL_INVITADO",
        payload: {
          status: true,
          invitado: response.data.invitado,
          vehiculos: response.data.invitado?.VehiculosData || [],
        },
      });
    } else {
      dispatch({
        type: "GET_DATOS_MENU_PRINCIPAL_INVITADO",
        payload: {
          status: false,
          message: response.data.message,
          vehiculos: [],
        },
      });
    }
  } catch (error) {
    console.error("Error in getDatosMenuPrincipalInvitado:", error);
    dispatch({
      type: "GET_DATOS_MENU_PRINCIPAL_INVITADO",
      payload: {
        status: false,
        message: error.message,
        vehiculos: [],
      },
    });
  }
};
